(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const slider = document.querySelector('.announcement-bar .slider--everywhere');
    if (!slider) return;
    const slides = slider.querySelectorAll('.slider__slide');
    if (!slides || slides.length <= 1) return;

    let current = 0;
    let intervalId = null;
    const SPEED = (parseInt(slider.dataset.speed) || 8) * 1000;

    function advance() {
      slides[current].classList.remove('is-active');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
    }

    // Show first slide and start rotation
    slides[0].classList.add('is-active');
    intervalId = setInterval(advance, SPEED);

    // Pause on hover, resume on leave
    slider.parentElement.addEventListener('mouseenter', function() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    });

    slider.parentElement.addEventListener('mouseleave', function() {
      if (!intervalId) {
        intervalId = setInterval(advance, SPEED);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Collapsible product description.
  // The "intro / mood" copy (everything before the phrase "Wallpaper Pieces")
  // collapses to a few lines with a "Read more" toggle. The "Wallpaper Pieces"
  // count breakdown always stays visible so shoppers know what's in the pack.
  // If the phrase is missing (older/other formats) we fall back to collapsing
  // the whole description. With JS off, everything shows (progressive enh.).
  (function () {
    var SPLIT_PHRASE = 'Wallpaper Pieces';
    var descriptions = document.querySelectorAll('[data-product-description]');

    descriptions.forEach(function (desc, i) {
      var hasPhrase = (desc.textContent || '').indexOf(SPLIT_PHRASE) !== -1;
      var intro = null;

      // Only split when the phrase exists AND there is intro copy before it.
      if (hasPhrase) {
        var fullText = desc.textContent || '';
        var idx = fullText.indexOf(SPLIT_PHRASE);

        if (idx > 0) {
          // Locate the text node + offset where the phrase STARTS.
          var walker = document.createTreeWalker(desc, NodeFilter.SHOW_TEXT, null);
          var pos = 0;
          var endContainer = null;
          var endOffset = 0;
          var node;
          while ((node = walker.nextNode())) {
            var len = node.nodeValue.length;
            if (pos + len > idx) { // phrase starts inside this text node
              endContainer = node;
              endOffset = idx - pos; // offset of the phrase START (not its end)
              break;
            }
            pos += len;
          }

          if (endContainer) {
            // Extract everything up to the START of the phrase into the intro
            // block; the phrase + count breakdown stay in place (always visible).
            var range = document.createRange();
            range.setStart(desc, 0);
            range.setEnd(endContainer, endOffset);
            var fragment = range.extractContents();
            if (fragment.childNodes.length) {
              intro = document.createElement('div');
              intro.className = 'product__description-intro';
              intro.id = 'ProductDescriptionIntro-' + i;
              intro.appendChild(fragment);
              desc.insertBefore(intro, desc.firstChild);
            }
          }
        }
      }

      var target;
      if (intro) {
        target = intro; // collapse only the intro; count breakdown stays visible
      } else if (!hasPhrase) {
        target = desc; // fallback: no split phrase -> collapse whole description
        target.id = 'ProductDescriptionIntro-' + i;
        target.classList.add('product__description-intro');
      } else {
        return; // phrase present but nothing before it: all copy is the count, no toggle
      }

      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'product__description-toggle link';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-controls', target.id);
      toggle.innerHTML =
        '<span class="product__description-toggle-more">Read more<span aria-hidden="true">&hellip;</span></span>' +
        '<span class="product__description-toggle-less">Read less</span>';
      target.parentNode.insertBefore(toggle, target.nextSibling);

      function syncToggle() {
        if (toggle.classList.contains('is-expanded')) return; // keep expanded choice
        target.classList.add('is-collapsed');
        var overflows = target.scrollHeight > target.clientHeight + 8;
        if (overflows) {
          toggle.hidden = false;
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          target.classList.remove('is-collapsed');
          toggle.hidden = true;
        }
      }

      syncToggle();

      toggle.addEventListener('click', function () {
        var expanded = toggle.classList.toggle('is-expanded');
        target.classList.toggle('is-collapsed', !expanded);
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });

      window.addEventListener('resize', syncToggle);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-home-hero"] && !Shopify.designMode) return;
  try {
    
  // Open the header search modal when the pill is clicked, the same behavior as
  // the hero-marquee search pill. Scoped to this section so it never double-binds
  // the hero-marquee's own pill on the old homepage.
  (function () {
    var pill = document.querySelector('.new-home-hero [data-hero-search-pill]');
    if (!pill) return;
    pill.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var modal = document.querySelector('details-modal.header__search');
      var trigger = (modal && modal.querySelector('summary')) ||
        document.querySelector('.header__icon--search');
      if (trigger) {
        trigger.click();
      } else {
        window.location.href = '/search';
      }
    });
  })();

  // Hide the right-edge gradient mask once the category row is scrolled to the
  // end (or when it never overflows), so it never covers the final tag.
  (function () {
    var wrap = document.querySelector('.new-home-hero__categories-wrap');
    var nav = wrap && wrap.querySelector('.new-home-hero__categories');
    if (!nav) return;

    function update() {
      var atEnd = nav.scrollLeft + nav.clientWidth >= nav.scrollWidth - 2;
      wrap.classList.toggle('new-home-hero__categories-wrap--end', atEnd);
    }

    update();
    nav.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  })();

  } catch(e) { console.error(e); }
})();
})();
